
import { Component, Vue } from 'vue-property-decorator'
import pagination from '@/components/Pagination/index.vue'
import detail from './components/detail.vue'
import auth from './components/auth.vue'
import add from './components/add.vue'
import secret from './components/secret.vue'
import { operationMessage } from '@/utils/message'
import { getList, delInfo, getInfo, getMenuAuthList } from '@/api/admin'
import { statusList } from '@/utils/constant'
import { isShowDialog } from '@/utils/permission'
import { getEnterprise } from '@/api/universal'
import { AppModule } from '@/store/modules/app'
import { delObjEmptyKey } from '@/utils'
import botSecret from './components/bot-secret.vue'

@Component({
  name: 'adminList',
  components: {
    pagination,
    detail,
    add,
    auth,
    secret,
    botSecret
  }
})
export default class extends Vue {
  private dialogVisible: boolean = false
  private botDialogVisible: boolean = false
  private action: string = ''
  private currentId: number | null = null
  private currentType: string = ''
  private currentUserPermission: number[] = []
  private isShowDetail: boolean = false
  private total = 0
  private listLoading = true
  private listQuery = {
    page: 1,
    limit: 20
  }
  private list: any[] = []
  private drawer: boolean = false
  private menuAuthList: any[] = []
  private statusList = statusList
  private queryForm: any = {
    username: '',
    email: ''
  }
  private enterpriseInfo: any = {}

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }
  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }
  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: 1
      }
      delObjEmptyKey(data)
      await getList(data).then((res: any) => {
        this.list = res.results
        this.total = res.count
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private select() {
    // this.getList(true)
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private reset() {
    this.queryForm.username = ''
    this.queryForm.email = ''
    this.currentPage = 1
    // this.getList(false)
    this.hadleGetFilesListApi()
  }

  get language() {
    return AppModule.language
  }
  // 获取管理员信息列表
  private async getList(isReset: boolean) {
    if (isReset) {
      this.listQuery.page = 1
    }
    const data: any = {
      ...this.queryForm,
      page: this.listQuery.page
    }
    this.listLoading = true
    await getList(data).then((res: any) => {
      this.list = res.results
      this.total = res.count
      this.listLoading = false
    })
  }

  private openDialogVisible(action: string, id: number | null) {
    this.dialogVisible = true
    this.action = action
    if (id !== null) {
      this.currentId = id
    }
  }

  private closeDialogVisible(b: boolean) {
    this.dialogVisible = b
    // this.getList(false)
    this.hadleGetFilesListApi()
  }

  private del(id: number) {
    if (this.language === 'en') {
      this.$confirm('Are you sure to delete it?', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning',
        callback: action => {
          if (action === 'confirm') {
            isShowDialog('delete_manager')
              ? this.openDialogVisible('del', id)
              : this.delInfo({ id: this.currentId })
          }
        }
      })
    }
    if (this.language === 'zh_cn') {
      this.$confirm('确定删除吗？', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
        callback: action => {
          if (action === 'confirm') {
            isShowDialog('delete_manager')
              ? this.openDialogVisible('del', id)
              : this.delInfo({ id: this.currentId })
          }
        }
      })
    }
    if (this.language === 'zh_tw') {
      this.$confirm('确定删除吗？', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
        callback: action => {
          if (action === 'confirm') {
            isShowDialog('delete_manager')
              ? this.openDialogVisible('del', id)
              : this.delInfo({ id: this.currentId })
          }
        }
      })
    }
  }

  private botId: any = ''
  private botIsReset: boolean = false
  private resetRobot(str: string, row: any) {
    if (str === 'showCode') {
      this.botIsReset = false
    } else {
      this.botIsReset = true
    }
    this.botId = row.id
    this.botDialogVisible = true
  }
  private batchReviewClose() {
    this.botDialogVisible = false
    this.hadleGetFilesListApi()
  }

  private async operationCb(info: any) {
    if (info) {
      const data: any = {
        id: this.currentId,
        ...info
      }
      await this.delInfo(data)
    }

    this.dialogVisible = false
  }

  private async delInfo(data: any) {
    await delInfo(data).then(() => {
      operationMessage(true)
    })
  }

  private async setStatus(row: any) {
    this.openDialogVisible('edit', row.id)
  }

  private async openAuth(id: number) {
    await this.getMenuAuthList(id)
    await this.getUserPermission(id).then(() => {
      this.currentId = id
      this.drawer = true
    })
  }

  // 获取菜单权限列表
  private async getMenuAuthList(id: number) {
    // const res: any = await getMenuAuthList(id)
    // this.menuAuthList = res
    const data = {
      id: id,
      language: this.language
    }
    await getMenuAuthList(data).then((res: any) => {
      this.menuAuthList = res
    })
  }

  // 获取菜单权限列表
  private async getUserPermission(id: number) {
    const res: any = await getInfo(id)
    this.currentType = res.manager_type
    this.currentUserPermission = res.permissions
  }

  // 获取平台信息
  private async getEnterpriseInfo() {
    try {
      await getEnterprise().then((res: any) => {
        this.enterpriseInfo = res
      })
    } catch (e) {}
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    // this.getList(false)
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.adminMgt`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
    this.getEnterpriseInfo()
    this.hadleGetFilesListApi()
  }
}
